import { createClient } from '@supabase/supabase-js';
import Logger from '../utils/logger';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://<project>.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '<your-anon-key>';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export async function getAccessToken(): Promise<string | null> {
  try {
    const { data, error } = await supabase.auth.getSession();
    if (error) {
      Logger.error('Error while getting session', error);
      return null;
    }
    return data.session?.access_token || null;
  } catch (error) {
    Logger.error('Error while getting session', error);
    return null;
  }
}
